export const font = {
  monospaceNumeric: {
    fontVariantNumeric: 'tabular-nums',
  },
};
